import { defineMessages } from 'react-intl';

const messages = defineMessages({
  NoPreviewAvailableForThisDocument: 'No preview available for this document.',
  FirstName: 'First name',
  LastName: 'Last name',
  DateOfBirth: 'Date of birth',
  Nationality: 'Nationality',
  Gender: 'Gender',
  PlaceOfBirth: 'Place of birth',
  NationalNumber: 'NationalNumber',
  Address: 'Address',
  Male: 'Male',
  Female: 'Female',
  ExpiryDate: 'Expiry date',
});

export default messages;
